import { create } from "zustand";
import axios from "axios";

const AUTH_STORAGE_KEY = "sportsforce-admin-auth";

interface AuthState {
  isAuthenticated: boolean;
  username: string | null;
  credentials: string | null; // base64 "username:password"
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
}

function loadFromStorage(): { credentials: string; username: string } | null {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.credentials && parsed.username) return parsed;
  } catch {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  }
  return null;
}

const stored = loadFromStorage();

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: !!stored,
  username: stored?.username ?? null,
  credentials: stored?.credentials ?? null,

  login: async (username: string, password: string) => {
    const credentials = btoa(`${username}:${password}`);
    const baseURL = import.meta.env.VITE_API_URL || "";

    try {
      await axios.get(`${baseURL}/admin/stats`, {
        headers: { Authorization: `Basic ${credentials}` },
        timeout: 10000,
      });

      localStorage.setItem(
        AUTH_STORAGE_KEY,
        JSON.stringify({ credentials, username })
      );
      set({ isAuthenticated: true, username, credentials });
      return true;
    } catch {
      return false;
    }
  },

  logout: () => {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    set({ isAuthenticated: false, username: null, credentials: null });
  },
}));
